import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "root",
  class: "gallery-grid"
}

import { chunkArrayHorizontal } from '@/js/utils/arrayUtils';
import FigureGridItem from './internals/FigureGridItem.vue';
import { computed, useTemplateRef } from 'vue';
import type { GalleryElement } from '@/interfaces/components/galleryElement';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import { navigateIndexIn2D } from 'src/utils/grids';

interface Props {
	/** Array of gallery items */
	items: GalleryElement[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryGrid',
  props: {
    items: {}
  },
  emits: ["itemClick", "itemArrowsNavigation"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const isTwoColumns = computed(() => useBreakpointStore().isMobile);
const cols = computed(() => (isTwoColumns.value ? 2 : 3));
const images = computed(() => chunkArrayHorizontal(props.items, cols.value));
const calculateTabIndex = (index: number, i: number) => index * images.value.length + i + 1;

const galleryRoot = useTemplateRef('root');

const focusElement = (index: number) => {
	const element = galleryRoot.value?.querySelector(`[data-order="${index}"]`) as HTMLElement;
	element?.focus({ preventScroll: true });
};

function onItemInteraction(item: GalleryElement, index: number) {
	emit('itemClick', item, index);
}
function onItemKeyDown(event: KeyboardEvent, currentIndex: number) {
	if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
		event.preventDefault();
		const elementIndex = navigateIndexIn2D(event.key, currentIndex, cols.value, props.items.length);
		focusElement(elementIndex);
		emit('itemArrowsNavigation', elementIndex);
	}
}

__expose({
	focusElement,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (chunk, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "gallery-grid__column"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (item, index) => {
          return (_openBlock(), _createBlock(FigureGridItem, _mergeProps({
            key: item.content,
            ref_for: true
          }, item, {
            "data-order": calculateTabIndex(index, i) - 1,
            tabindex: calculateTabIndex(index, i),
            onClick: ($event: any) => (onItemInteraction(item, calculateTabIndex(index, i) - 1)),
            onKeydown: [
              _withKeys(_withModifiers(($event: any) => (onItemInteraction(item, calculateTabIndex(index, i) - 1)), ["prevent"]), ["enter"]),
              ($event: any) => (onItemKeyDown($event, calculateTabIndex(index, i) - 1))
            ]
          }), null, 16 /* FULL_PROPS */, ["data-order", "tabindex", "onClick", "onKeydown"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 512 /* NEED_PATCH */))
}
}

})